var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(_vm.$route.path !== '/login')?_c('nav-bar'):_vm._e(),(_vm.$route.path !== '/login')?_c('top-header'):_vm._e(),_c('global-snack-bar'),_c('div',{staticClass:"mr-16 pr-16 mb-8 mt-16 ml-4"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }